import { useState } from 'react'
import { createGlobals } from '../context/createGlobals'

export enum FETCH_INTERVAL_KEY {
  OUT = 'out',
  IN = 'in',
}

type iFetchKey = typeof FETCH_INTERVAL_KEY[keyof typeof FETCH_INTERVAL_KEY]

const DEF_INTERVAL_SEC = 600 // 10 minut
let TIMER_INTERVAL: any = {}
const initState = { [FETCH_INTERVAL_KEY.IN]: 0, [FETCH_INTERVAL_KEY.OUT]: 0 }
const { useGlobalState } = createGlobals(initState)

export const useFetchInterval = <T> (fetchFn: () => Promise<T>, key: iFetchKey, intervalSec: number = DEF_INTERVAL_SEC) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useGlobalState(key)

  const fetchData = async () => {
    clearInterval(TIMER_INTERVAL[key])
    setError('')
    setLoading(true)
    try {
      const result: any = await fetchFn()
      setData(result)
    } catch (error: any) {
      setError(error.toString())
    } finally {
      setLoading(false)
      TIMER_INTERVAL[key] = setInterval(fetchData, intervalSec * 1000)
    }
  }

  return { data, loading, error, fetchData }
}
